import {api} from "@/store/resources";
import {i18n} from "@/i18n";

export default {
    namespaced: true,
    state: {
        fetched: false,
        locale: i18n.locale,
        constants: {
            default_currency: [],
            space: [],
            space_import: [],
            contractor: [],
            account_type: [],
            income_category_group: [],
            income_involvement: [],
            income_category: [],
            ticket_status: [],
            ticket_subject: [],
            ticket_priority: [],
        }
    },
    getters: {
        cabinetConstantsFetched: (state) => state.fetched,
        getConstantList: state => constant => state.constants[constant]
    },
    actions: {
        async fetchConstants({commit, rootState, state}, locale = state.locale) {
            if (state.locale === locale && state.fetched) return;
            const res = await api.constants_enums.get({locale});
            commit('storeConstants', {locale, payload: res.body.data});
        }
    },
    mutations: {
        storeConstants(state, {locale, payload}) {
            state.fetched = true;
            state.locale = locale;
            state.constants = Object.freeze(payload);
        }
    },
}